import React from 'react'
import { withRouter } from 'react-router-dom'
import { MenuItem } from 'react-bootstrap'

class MenuItemWithoutRouter extends React.Component {
  handleLink = path => {
    this.props.history.push(path)
  }

  render() {
    const { to, eventKey, children, onSelect } = this.props
    return (
      <MenuItem
        href={to}
        eventKey={eventKey}
        onSelect={onSelect}
        onClick={() => this.handleLink(to)}
      >
        {children}
      </MenuItem>
    )
  }
}

const MenuItemLink = withRouter(MenuItemWithoutRouter)
export default MenuItemLink



// WEBPACK FOOTER //
// ./src/components/MenuItemLink.js